import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

export const dialogTitleId = "Dialog-title";

interface PortalProps {
  buttonToRender: JSX.Element;
}

const DialogHeaderPortal = ({ buttonToRender }: PortalProps) => {
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById(dialogTitleId));
  }, []);

  return (
    portalHeader &&
    ReactDOM.createPortal(
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {buttonToRender}
      </Grid>,
      portalHeader
    )
  );
};

export default DialogHeaderPortal;
